import styles from "../creditreport.module.css";

const TierRow = ({ name, range, width, color, count }) => {
    return (<div className={styles.tierRow}>
        <div className={styles.tierLabelBlock}>
            <span className={styles.tierName}>{name}</span>
            <span className={styles.tierRange}>{range}</span>
        </div>
        <div className={styles.tierBarBg}>
            <div className={styles.tierBarFill} style={{ width: `${width}%`, background: color }} />
        </div>
        <span className={styles.tierCount}>{count}</span>
    </div>);
}

export default TierRow;